export default __webpack_public_path__ + "static/media/lindau-russdorf.b736a1a1.jpg";